import { api } from '@/shared'
import { message } from 'antd'
import { contractCivilLowActions } from '@/entity'

export const getXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.getXmlAction(data))
			const res = await api.contractCivilLow.getXml(data)
			let result = {xml: res.data, item: {externalId: res.externalId, ...data}}
			dispatch(contractCivilLowActions.getXmlActionDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.getXmlActionFail())
		}
	}
}

export const sendContract = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendContractAction(data))
			const res = await api.contractCivilLow.sendContract(data)
			dispatch(contractCivilLowActions.sendContractActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendContractActionFail())
		}
	}
}

export const getContracts = ({ data, params, onSuccess }, cache = false) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.getContractsAction())
			const res = await api.contractCivilLow.page(data, params, cache)
			dispatch(contractCivilLowActions.getContractsActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.getContractsActionFail())
		}
	}
}

export const getContract = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.getContractAction())
			const res = await api.contractCivilLow.getContract(data)
			dispatch(contractCivilLowActions.getContractActionDone(res))
			dispatch(contractCivilLowActions.setModalData({item: res}))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.getContractActionFail())
		}
	}
}

export const subSend = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendSubContractAction(data))
			const res = await api.contractCivilLow.subSend(data)
			dispatch(contractCivilLowActions.sendSubContractActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendSubContractActionFail())
		}
	}
}

export const subGetXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.getXmlAction(data))
			const res = await api.contractCivilLow.subGetXml(data)
			let result = {xml: res.data, item: {externalId: res.externalId, ...data}}
			dispatch(contractCivilLowActions.getXmlActionDone(result))
			onSuccess(result)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendSubGetXmlActionFail())
		}
	}
}

export const delGetXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendDelGetXmlAction(data))
			const res = await api.contractCivilLow.delGetXml(data)
			dispatch(contractCivilLowActions.sendDelGetXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendDelGetXmlActionFail())
		}
	}
}

export const subDelGetXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendSubDelGetXmlAction(data))
			const res = await api.contractCivilLow.subDelGetXml(data)
			dispatch(contractCivilLowActions.sendSubDelGetXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendSubDelGetXmlActionFail())
		}
	}
}

export const termGetXml = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendTermGetXmlAction(data))
			const res = await api.contractCivilLow.termGetXml(data)
			dispatch(contractCivilLowActions.sendTermGetXmlActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendTermGetXmlActionFail())
		}
	}
}

export const termSend = ({ data, onSuccess }) => {
	return async (dispatch) => {
		try {
			dispatch(contractCivilLowActions.sendTermAction(data))
			const res = await api.contractCivilLow.termSend(data)
			dispatch(contractCivilLowActions.sendTermActionDone(res))
			onSuccess(res)
		} catch (error) {
			message.error(error.response?.data?.message)
			dispatch(contractCivilLowActions.sendTermActionFail())
		}
	}
}